export default __webpack_public_path__ + "e882bb577919855fd8d210903b9b975f.ogg";